import { Container } from "../../../types";

export function wiggle(scene: Phaser.Scene, card: Container) {
  scene.tweens.add({
    targets: card,
    rotation: { from: 0.4, to: 0 },
    ease: "Elastic",
  });
}
